import { Tooltip } from "bootstrap";
import { ReactElement, useRef, useEffect } from "react";
import { renderToString } from "react-dom/server";

export const AdditionalInfoButton = (props: { additionalInfo: ReactElement }) => {
    const { additionalInfo } = props;

    const additionalInfoRef = useRef<HTMLButtonElement>(null);

    useEffect(() => {
        if (additionalInfoRef.current && additionalInfo) {
            Tooltip.getOrCreateInstance(additionalInfoRef.current).enable();
        }
    }, [additionalInfo]);

    return (
        <button
            title={renderToString(additionalInfo)}
            data-bs-placement="right"
            data-bs-toggle="tooltip"
            tabIndex={-1}
            data-bs-html="true"
            ref={additionalInfoRef}
            type="button"
            className="btn btn-sm rounded-pill ms-3 p-0"
        >
            <span className="fas fa-info-circle text-secondary"></span>
        </button>
    );
};
